import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-edit",
  templateUrl: "./edit.component.html",
  styleUrls: ["./edit.component.scss"],
})
export class EditComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
